module.exports = __webpack_public_path__ + "img/E2 You.7a1236df.png";